export { Facebook } from './Facebook';
export { MetaBreadcrumbs } from './MetaBreadcrumbs';
export { SchemaBreadcrumbs } from './SchemaBreadcrumbs';
export { SocialMedia } from './SocialMedia';
export { Twitter } from './Twitter';
import { SocialMedia } from './SocialMedia';

export { HrefLang } from './HrefLang';
export default SocialMedia;
